import React from 'react';
import privacyBanner from '../images/privacy-policy-banner.jpg';
import './Policies.css';

const Policies = () => {
  const policies = [
    {
      name: 'Anti Corruption',
      path: '/Anti%20Corruption.pdf',
      icon: '📄'
    },
    {
      name: 'Compromise Settlement and Technical Write off Policy',
      path: '/Compromise%20Settlement%20and%20Technical%20Write%20off%20Policy.pdf',
      icon: '📄'
    },
    {
      name: 'Corporate Governance',
      path: '/Corporate%20Governance.pdf',
      icon: '📄'
    },
    {
      name: 'Digital Lending',
      path: '/Digital%20Lending.pdf',
      icon: '📄'
    },
    {
      name: 'Fair Practices Code',
      path: '/Fair%20Practice%20Code.pdf',
      icon: '📄'
    },
    {
      name: 'Grievance Redressal Policy',
      path: '/Grievance%20Redressal%20Policy%20%281%29.pdf',
      icon: '📄'
    },
    {
      name: 'IT Policy',
      path: '/IT%20Policy.pdf',
      icon: '📄'
    },
    {
      name: 'Interest Rate Policy',
      path: '/Interest%20Rate%20Policy%20%282%29.pdf',
      icon: '📄'
    },
    {
      name: 'KYC and AML',
      path: '/KYC%20and%20AML.pdf',
      icon: '📄'
    },
    {
      name: 'Loan to Directors',
      path: '/Loan%20to%20Directors.pdf',
      icon: '📄'
    },
    {
      name: 'NPA Policy',
      path: '/NPA%20Policy.pdf',
      icon: '📄'
    },
    {
      name: 'Related Party Transactions',
      path: '/Related%20Party%20Transactions.pdf',
      icon: '📄'
    },
    {
      name: 'Remuneration Policy',
      path: '/Remuneration%20Policy.pdf',
      icon: '📄'
    },
    {
      name: 'Stat Auditor Policy',
      path: '/Stat%20Auditor%20Policy.pdf',
      icon: '📄'
    },
    {
      name: 'Whistle Blower',
      path: '/Whiste%20Blower.pdf',
      icon: '📄'
    }
  ];

  return (
    <div className="policies-page">
      {/* Banner Section */}
      <section className="policies-banner">
        <div className="policies-banner-wrapper">
          <div className="banner-image" style={{ backgroundImage: `url(${privacyBanner})` }}>
            <div className="banner-overlay">
              <h1 className="banner-heading">AMPIRE FINANCE</h1>
            </div>
          </div>
          <div className="banner-content">
            <h2 className="banner-title">POLICIES</h2>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="policies-content">
        <div className="policies-wrapper">
          <div className="policies-list">
            {policies.map((policy, index) => (
              <a
                key={index}
                href={policy.path}
                target="_blank"
                rel="noopener noreferrer"
                className="policy-item policy-cta"
              >
                <div className="policy-icon">{policy.icon}</div>
                <div className="policy-name">{policy.name}</div>
                <div className="policy-arrow">↗</div>
              </a>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Policies;




